/**
 * The one field of the roof type card: the quality block writes the roof type of the measurement
 * too (see feature page projekt-protokolle).
 */
export const MEASUREMENT_ROOF_TYPE_PATH = 'measurement.roofType';

const toCompletedInput = (completed) =>
  (completed ?? []).map(({ type, value }) => ({ type, value }));

/**
 * Sparse `ProjectQualityReportDataInput` of one card: the values of `fieldPaths` (direct fields of
 * `qualityReport`, e.g. `isRoofAccessibleFromInsideState`) plus the card states `completed`; the
 * roof type card (`fieldPaths` holds `MEASUREMENT_ROOF_TYPE_PATH`) sends `roofType` as
 * `measurement { roofType }`. Every card state, the roof type card's included, lives in
 * `qualityReport.completed`. Photos have their own mutations.
 */
export const toQualityCardInput = (qualityReport, fieldPaths, roofType = null) => {
  const qualityFieldNames = fieldPaths.filter((path) => path !== MEASUREMENT_ROOF_TYPE_PATH);
  const input = {
    qualityReport: {
      ...Object.fromEntries(
        qualityFieldNames.map((fieldName) => [fieldName, qualityReport?.[fieldName] ?? null])
      ),
      completed: toCompletedInput(qualityReport?.completed),
    },
  };
  if (fieldPaths.includes(MEASUREMENT_ROOF_TYPE_PATH)) {
    input.measurement = { roofType: roofType ?? null };
  }

  return input;
};
